<template>
  <div class="painel-atendimentos">
    <h2>{{$t('PainelAtendimento.Title')}}</h2>

    <div class="filters">
      <div class="filter-container">
        <div class="filter-wrapper">
          <div class="filter-row">

            <!-- Data inicial -->
            <v-menu
              v-model="menuStart"
              :close-on-content-click="false"
              transition="scale-transition"
              min-width="auto"
              content-class="menu-datepicker"
              offset-y
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-bind="attrs"
                  v-on="on"
                  :label="$t('PainelAtendimento.StartDate')"
                  v-model="startDate"
                  readonly
                  append-icon="mdi-calendar"
                  
                />
              </template>
              <v-date-picker locale="pt-br" v-model="startDate" no-title scrollable />
            </v-menu>

            <!-- Data final -->
            <v-menu
              v-model="menuEnd"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="auto"
              content-class="menu-datepicker"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-bind="attrs"
                  v-on="on"
                  :label="$t('PainelAtendimento.EndDate')"
                  v-model="endDate"
                  readonly
                  append-icon="mdi-calendar"
                />
              </template>
              <v-date-picker locale="pt-br" v-model="endDate" no-title scrollable />
            </v-menu>

            <!-- Botões -->
            <v-btn text @click="getPainelAtendimentoData"> {{ $t('PainelAtendimento.Filter') }}</v-btn>
          </div>
        </div>
      </div>
    </div>
  <div class="dashboard-grid" v-if="kpis">

    <div class="dashboard-card card-realtime">
      <h3>{{ $t('PainelAtendimento.TitleRealTime') }}</h3>

      <div class="kpi-row">
         <div class="kpi-item color">
          <strong>{{ kpis.naFila }}</strong>
          <span>{{ $t('PainelAtendimento.TitleInQueue') }}</span>
        </div>

        <div class="kpi-item">
          <strong>{{ kpis.tempoMaximoFila }}</strong>
          <span>{{ $t('PainelAtendimento.TitleMaxTime')}}</span>
        </div>

        <div class="kpi-item color">
          <strong >{{ kpis.emAtendimento }}</strong>
          <span>{{ $t('PainelAtendimento.TitleInAttendance')}}</span>
        </div>

        <div class="kpi-item">
          <strong>{{ kpis.mediaTicketsPorAtendente }}</strong>
          <span>{{ $t('PainelAtendimento.TitleAverageTickets')}}</span>
        </div>
      </div>
    </div>

    <div class="dashboard-card card-agents">
      <h3>{{ $t('PainelAtendimento.TitleAgentStatus') }}</h3>

      <div class="kpi-row center">
        <div class="kpi-status">
          <span class="dot green"></span>
          <strong>{{ kpis.operadoresOnline }}</strong>
          <span>{{ $t('PainelAtendimento.AgentStatusOnline') }}</span>
        </div>
        <div class="kpi-status">
          <span class="dot gray"></span>
          <strong>{{ kpis.operadoresInvisiveis }}</strong>
          <span>{{ $t('PainelAtendimento.AgentStatusUnavailable') }}</span>
        </div>
      </div>
    </div>

    <div class="dashboard-card card-today">
      <h3>{{ $t('PainelAtendimento.TitleAttendance') }}</h3>

      <div class="kpi-row">
        <div class="kpi-item">
          <strong>{{ kpis.tempoMedioEspera }}</strong>
          <span>{{ $t('PainelAtendimento.TitleAverageTimeWaiting') }}</span>
        </div>

        <div class="kpi-item">
          <strong>{{ kpis.tempoMedioResposta || "00:00:00" }}</strong>
          <span>{{ $t('PainelAtendimento.TitleAnswerAverageTime') }}</span>
        </div>        

        <div class="kpi-item">
          <strong>{{ kpis.tempoMedioAtendimento }}</strong>
          <span>{{ $t('PainelAtendimento.TitleAverageAttendanceTime') }}</span>
        </div>
      </div>
    </div>

    <div class="dashboard-card card-tickets">
      <h3>{{ $t('PainelAtendimento.TitleStatusTickets') }}</h3>

      <div class="kpi-row center">
        <div class="kpi-item danger">
          <strong>{{ kpis.perdidos }}</strong>
          <span>{{ $t('PainelAtendimento.StatusTicketsLost') }}</span>
        </div>

        <div class="kpi-item danger">
          <strong>0</strong>
          <span>{{ $t('PainelAtendimento.STatusTicketsAbandoned') }}</span>
        </div>

        <div class="kpi-item">
          <strong>{{ kpis.fechados }}</strong>
          <span>{{ $t('PainelAtendimento.StatusTicketsClosed') }}</span>
        </div>
      </div>
    </div>   
  </div>
  <v-card class="mt-4">
  <v-card-title class="d-flex justify-space-between align-center">
  <span class="text-subtitle-1 font-weight-bold">
    {{ $t('PainelAtendimento.TitleAttendanceByAgent') }}
  </span>

  <v-btn
    small
    color="primary"
    @click="exportCsv"
  >
    {{ $t('PainelAtendimento.ButtonExport') }}
  </v-btn>
</v-card-title>

  <v-data-table
    :headers="agentHeaders"
    :items="agentTableItems"
    dense
    class="elevation-1"
    :items-per-page="10"
  >
  <template slot="item.actions" slot-scope="{ item }">
    <v-icon
      small
      color="primary"
      class="mr-2"
      @click="goToDetalheAtendimentos(item.agent_Id)"
    >
      mdi-eye
    </v-icon>
  </template>
    <template v-slot:no-data>
      {{ $t('PainelAtendimento.TextEmptyList') }}
    </template>
  </v-data-table>
</v-card>


  </div>
</template>

<script>
import { mapGetters } from "vuex";
import axios from 'axios';

export default {
  name: "PainelAtendimentos",
  data() {
  const today = new Date().toISOString().substr(0, 10);

  return {
    startDate: today,
    endDate: today,
    menuStart: false,
    menuEnd: false,
    operadoresOnline: 0,
    operadoresInvisiveis: 0,
    operadoresTotal: 0,
    totalAttendence: 0,
    abandonados: 0,
    client: null,
    ext_opp : axios.create({
        baseURL: process.env.VUE_APP_ENV_API_ATT_EXT_OPP
    }),
    agentHeaders: [
      { text: this.$t("PainelAtendimento.Headers.Agent"), value: "atendente" },
      { text: this.$t("PainelAtendimento.Headers.OpenTickets"), value: "tickets_Em_Aberto", align: "center" },
      { text: this.$t("PainelAtendimento.Headers.AverageAnswerTime"), value: "tempoResposta", align: "center" },
      { text: this.$t("PainelAtendimento.Headers.AverageAttendanceTime"), value: "tempoAtendimento", align: "center" },
      { text: this.$t("PainelAtendimento.Headers.Actions"), value: "actions", align: "center", sortable: false }
    ]
  };
},

  computed: {
    ...mapGetters([
      "getPainelAtendimento", 
      "getListDataInformation", 
      "getCurrentCustomer",
      "getAgentAttendanceDetails"
    ]),
    agentTableItems() {
      if (!Array.isArray(this.getAgentAttendanceDetails)) return [];

      return this.getAgentAttendanceDetails.map(a => ({
        agent_Id: a.agent_Id,
        atendente: (a.atendente || "").trim(),
        tickets_Em_Aberto: a.tickets_Em_Aberto ?? 0,
        tempoResposta: this.formatSeconds(a.tempo_Medio_Resposta_Segundos),
        tempoAtendimento: this.formatSeconds(a.tempo_Medio_Atendimento_Segundos)
      }));
    },
     kpis() {
      const r = this.getPainelAtendimento;
      if (!r) return null;

      const mediaTicketsPorAtendente =
        this.operadoresTotal > 0
          ? (this.totalAttendence / this.operadoresTotal).toFixed(1)
          : 0;
      console.log("Painel Atendimento KPIs data:", r);
      return {
        // Atendimento em tempo real
        naFila: r.atendimentos_Em_Fila,
        tempoMaximoFila: this.formatSeconds(r.tempo_Maximo_Em_Espera_Segundos),
        emAtendimento: r.atendimentos_Em_Aberto,
        mediaTicketsPorAtendente,

        // Atendimento hoje
        tempoMedioEspera: this.formatSeconds(r.tempo_Medio_Espera_Segundos),
        tempoMedioAtendimento: this.formatSeconds(r.tempo_Medio_Em_Atendimento_Segundos),

        // Operadores
        operadoresOnline: this.operadoresOnline,
        operadoresInvisiveis: this.operadoresInvisiveis,

        // Status dos tickets
        perdidos: r.atendimentos_Perdidos,
        abandonados: this.abandonados,
        fechados: r.atendimentos_Fechados
      };
    }
  },
  methods: {
    goToDetalheAtendimentos(agent_Id) {
      this.$router.push({
          name: "detalheAtendimentos",
          params: { 
            id: agent_Id, 
            initialStartDate: this.startDate, 
            initialEndDate: this.endDate 
          }
        });
    },
    exportCsv() {
    if (!this.agentTableItems.length) {
      return;
    }

    const headers = [
      this.$t("PainelAtendimento.Headers.Agent"),
      this.$t("PainelAtendimento.Headers.OpenTickets"),
      this.$t("PainelAtendimento.Headers.AverageAnswerTime"),
      this.$t("PainelAtendimento.Headers.AverageAttendanceTime")
    ];

    const rows = this.agentTableItems.map(item => [
      item.atendente,
      item.tickets_Em_Aberto,
      item.tempoResposta,
      item.tempoAtendimento
    ]);

    const csvContent = this.arrayToCsv([headers, ...rows]);
    this.downloadCsv(csvContent, "atendimento_por_agente.csv");
    },

    arrayToCsv(data) {
    var dataRet = data;
      return dataRet
        .map(row =>
          row
            .map(value => `"${String(value).replace(/"/g, '""')}"`)
            .join(";")
        )
        .join("\n");
    },

    downloadCsv(content, fileName) {
      const blob = new Blob([content], { type: "text/csv;charset=utf-8;" });
      const url = URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    },
    getLocalDate(start_Queue) {
      let newDate = new Date(start_Queue + 'Z');
      let valYear = newDate.getFullYear()
      let formatDate = null;
      if(valYear < 2000) {
        formatDate = ""
      } else {
        formatDate =
        [
          newDate.getFullYear(),
          newDate.getMonth()+1,
          newDate.getDate()
        ].join('-') +' ' +
        [newDate.getHours(),
          String(newDate.getMinutes()).padStart(2, '0'),
          String(newDate.getSeconds()).padStart(2, '0')].join(':').toString();
      }

      return formatDate;
    },
    utcMethod(date) {
      let data = new Date(date);
      var dataBase = data.toISOString().replace(/\.\d{3}Z$/, '');

      return dataBase;
    },
    async changeCustomer() {
      await this.fetchLightDashboard();
      await this.getPainelAtendimentoData();
    },
     async fetchLightDashboard() {
      const dateStart = this.startDate + "T00:00:00";
      const dateEnd = this.endDate + "T23:59:59";

      try {
        const r = await this.ext_opp.get(
          `Light_Dashboard?customer_id=${localStorage.getItem("customer_Id")}&start_date_time=${this.utcMethod(dateStart)}&end_date_time=${this.utcMethod(dateEnd)}`,
          { headers: { accept: "*/*" } }
        );

        this.operadoresOnline = r.data.number_Agents_Enable;
        this.operadoresInvisiveis = r.data.number_Agents_Disable;
        this.operadoresTotal = r.data.total_Agents;
        this.totalAttendence = r.data.total_Attendence;
        this.abandonados = r.data.number_Interactions_Abandoned;
        console.log("Light Dashboard data:", r.data);
      } catch (err) {
        console.error("Erro Light Dashboard", err);
      }
    },
    formatCell(v) {
      if (v === null || v === undefined) return "";
      if (typeof v === "string" && /^\d{4}-\d{2}-\d{2}T/.test(v)) return new Date(v).toLocaleString();
      return v;
    },    
    async getPainelAtendimentoData() {
      console.log("startDate", this.startDate);
      console.log("endDate", this.endDate);
      const payload = {
        customerId: localStorage.getItem("customer_Id"),
        startDate: this.startDate,
        endDate: this.endDate        
      };
      
      await this.$store.dispatch('getPainelAtendimento', payload);
      await this.$store.dispatch("getAgentAttendanceDetails", payload);
      console.log("return painel atendimento:", this.getAgentAttendanceDetails);
      await this.fetchLightDashboard();
     
    },  
    formatSeconds(seconds) {
      if (!seconds && seconds !== 0) return "00:00:00";

      const h = Math.floor(seconds / 3600);
      const m = Math.floor((seconds % 3600) / 60);
      const s = Math.floor(seconds % 60);

      return [h, m, s].map(v => String(v).padStart(2, "0")).join(":");
    },
  },
  mounted() {

    if (this.$store.state.currentCustomer == null) {
        this.client = this.getListDataInformation[0];
    } else {
        this.client = this.$store.state.currentCustomer;
    }
    this.changeCustomer();
  },
  watch:{
     getCurrentCustomer() {
      this.client = this.getCurrentCustomer;
      this.changeCustomer()
    }
  }

};
</script>

<style scoped>
.dashboard-grid {
  display: grid;
  grid-template-columns: 2fr 1fr;
  grid-template-rows: 1fr 1fr; /* 🔥 linhas iguais */
  grid-template-areas:
    "realtime agents"
    "today tickets";
  gap: 10px;
  width: 100%;
  margin-bottom: 24px;
  padding: auto;
}

/* cards ocupam toda a célula */
.dashboard-card {
  background: #fff;
  border-radius: 12px;
  padding: 6px 10px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.08);

  height: 100%;              /* 🔥 essencial */
  display: flex;
  flex-direction: column;
}

/* conteúdo centralizado verticalmente */
.kpi-row {
  flex: 1;                   /* 🔥 preenche o card */
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.dashboard-card h3 {
  font-size: 14px;
  font-weight: 600;
  margin: 0 0 6px 0;   /* 🔥 antes tinha 10px */
  line-height: 1.2;
}
card-realtime {
  grid-area: realtime;
   padding: 14px 16px; 
}

.card-agents {
  grid-area: agents;
  padding: 6px 10px;
}

.card-agents .kpi-row {
  flex-wrap: nowrap;
  gap: 20px;
}

.card-today {
  grid-area: today;
   padding: 8px 12px; 
}
.card-realtime .kpi-row,
.card-today .kpi-row {
  gap: 10px;
}

.card-realtime .kpi-item strong,
.card-today .kpi-item strong {
  font-size: 22px;
}
.card-tickets {
  grid-area: tickets;
}


.kpi-row.center {
  justify-content: center;
}

.kpi-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 100px;
}

.kpi-item strong,
.kpi-status strong {
  font-size: 20px;     
  line-height: 1.1;   
  margin: 0;
}


.kpi-item.danger strong {
  color: #e53935;
}

.kpi-item.color strong{
  color: #1a73e8;
}

.kpi-item span,
.kpi-status span {
  font-size: 11px;
  line-height: 1.15;
  margin: 2px 0 0;
}


.kpi-status {
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 100px;
}



.dot {
  width: 8px;
  height: 8px;
  margin-bottom: 2px; 
}

.green { background: #2ecc71; }
.yellow { background: #f1c40f; }
.gray { background: #9e9e9e; }

/* Responsivo */
@media (max-width: 900px) {
  .dashboard-grid {
    grid-template-columns: 1fr;
  }
}

.filters { display:flex; gap:12px; align-items:center; margin-bottom:12px; width: 100%; flex-wrap:wrap; }
.table { width:100%; border-collapse:collapse; }
.table th, .table td { border:1px solid #ddd; padding:8px; text-align:left; }
.empty { color:#666; padding:8px; }
.filter-container {
   width: 100%;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.filter-wrapper {
   width: 100%;
  background-color: white;
  border-radius: 10px;
  padding: 20px;
}

.filter-row {
  display: flex;
   width: 100%;
  gap: 16px;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
}

.menu-datepicker {
  z-index: 3000 !important;
  max-width: none !important; /* 🔥 ISSO RESOLVE */
}

.menu-datepicker .v-picker {
  background-color: #fff;
  overflow: hidden; /* 🔥 evita qualquer bleed visual */
}

.menu-datepicker .v-picker__body {
  width: auto !important;
}

.v-date-picker-header__value button {
  text-transform: capitalize;
}
:deep(.v-date-picker-header__value button) {
  text-transform: capitalize;
}

</style>